import { forwardRef } from 'react';
import type { BadgeProps } from '@elfsight/widget-ui';
import { Badge } from '@elfsight/widget-ui';
import type { BlockProps } from '../_block';
import { Block } from '../_block';

export type BadgeBlockProps = BlockProps &
  BadgeProps & {
    text: string;
    applyMobileSettings: boolean;
    borderRadius?: BadgeProps['borderMode'];
    mobileSize?: BadgeProps['size'];
  };

export const BadgeBlock = forwardRef<HTMLDivElement, BadgeBlockProps>(
  (
    {
      alignment,
      style,
      text,
      applyMobileSettings,
      size,
      mobileSize,
      borderRadius,
      ...forwardingProps
    },
    forwardingRef
  ) => {
    return (
      <Block ref={forwardingRef} alignment={alignment} style={style}>
        <Badge
          {...forwardingProps}
          borderMode={borderRadius}
          size={applyMobileSettings ? mobileSize : size}
        >
          {text}
        </Badge>
      </Block>
    );
  }
);
